import { create } from 'zustand/react';

interface NavigationState {
  searchParamsByPath: Record<string, string>;
  setSearchParamsForPath: (path: string, search: string) => void;
  getSearchParamsForPath: (path: string) => string;
}

export const useNavigationStateStore = create<NavigationState>((set, get) => ({
  searchParamsByPath: {},
  setSearchParamsForPath: (path, search) =>
    set((state) => ({
      searchParamsByPath: {
        ...state.searchParamsByPath,
        [path]: search,
      },
    })),
  getSearchParamsForPath: (path) => get().searchParamsByPath[path] ?? '',
}));
